import { h, Fragment } from 'preact'
import { tagParser } from '../../js/modules/utilities.js'
import fibres from './fibres.svg'

export const TuileOffre = ({ title, tag, from_price, price_without_promo, per_month, image, sr_only, price, mentions, CTA: { URL, analytics }, attributes }) => {
   document.documentElement.style.setProperty('--img-fibres-offre', `url(${fibres})`)

   return (
      <a
         href={URL}
         class="tuile-offre"
         data-pdb-zid={analytics.pdbZid}
         data-pdb-sc={analytics.pdbSc}
         data-pdb-idc={analytics.pdbIdc}
         data-pdb-vi={analytics.pdbVi}
         data-pdb-ta={analytics.pdbTa}
         data-adv-canal={analytics.advCanal}
         data-adv-cappingdata={analytics.advCappingdata}
         data-oevent-category={analytics.oeventCategory}
         data-oevent-action={analytics.oeventAction}
         data-oevent-label={analytics.oeventLabel}
         data-oevent-other={analytics.oeventOther}
      >
         {tag && (
            <div class="tag">
               <div class="ob1-tag ob1-tag-primary">{tag}</div>
            </div>
         )}

         <div class="content">
            <div>
               <h3 class="h4 title" dangerouslySetInnerHTML={{ __html: tagParser(title) }}></h3>
               <ul class="attributes-list">
                  {attributes.map(({ icon, label }) => (
                     <li>
                        <span class={`icon icon-${icon}`} aria-hidden="true"></span> <span class="lead p-0 label" dangerouslySetInnerHTML={{ __html: tagParser(label) }}></span>
                     </li>
                  ))}
               </ul>
            </div>
            <div class="image">
               <img src={image} alt="" loading="lazy" />
            </div>
         </div>

         <div class="price ob1-price text-right" data-ob1-component="Price">
            <span class="sr-only">{sr_only}</span>
            <p aria-hidden="true">
               {price_without_promo && per_month && !from_price ? (
                  <s class="ob1-price-without-promo">{price_without_promo}&nbsp;€</s>
               ) : (
                  from_price && <span class="ob1-price-from">à partir de</span>
               )}

               <span class="ob1-price-amount">{price}&nbsp;€</span>

               {per_month ? (
                  <span class="ob1-price-by-month"> {per_month && '/mois'}</span>
               ) : (
                  price_without_promo && (
                     <s style={{ display: 'inline', paddingLeft: '5px' }} class="ob1-price-without-promo">
                        {price_without_promo} €
                     </s>
                  )
               )}
               <span class="ob1-price-promo-duration" dangerouslySetInnerHTML={{ __html: tagParser(mentions) }}></span>
            </p>
         </div>
      </a>
   )
}
